import { useEffect } from 'react'

interface NavigationItem {
  id: string
  label: string
  path: string
  shortcut: string
}

export const useKeyboardShortcuts = (
  onToggle: () => void,
  onNavigate: (path: string) => void,
  navigationItems: NavigationItem[]
): void => {
  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      // Don't trigger shortcuts when typing in input fields
      const target = event.target as HTMLElement
      if (
        target.tagName === 'INPUT' ||
        target.tagName === 'TEXTAREA' ||
        target.isContentEditable
      ) {
        return
      }

      // Ctrl+B or Cmd+B to toggle navigation
      if ((event.ctrlKey || event.metaKey) && event.key === 'b') {
        event.preventDefault()
        onToggle()
        return
      }

      // Escape key to collapse navigation (desktop) or close mobile menu
      if (event.key === 'Escape') {
        event.preventDefault()
        onToggle()
        return
      }

      // Alt+1 through Alt+7 for navigation shortcuts
      if (event.altKey && event.key >= '1' && event.key <= '7') {
        event.preventDefault()
        const index = parseInt(event.key) - 1
        if (navigationItems[index]) {
          onNavigate(navigationItems[index].path)
        }
        return
      }
    }

    window.addEventListener('keydown', handleKeyDown)
    return () => window.removeEventListener('keydown', handleKeyDown)
  }, [onToggle, onNavigate, navigationItems])
}
